import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-分页",
  "use": "icon-分页-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-分页\"><defs><style type=\"text/css\"></style></defs><path d=\"M742.4 128.512H409.6a25.6 25.6 0 0 0-17.92 7.68l-230.4 230.912a25.6 25.6 0 0 0-7.68 17.92V819.2a128 128 0 0 0 128 128h460.8A128 128 0 0 0 870.4 819.2V256a128 128 0 0 0-128-127.488zM393.728 204.8v153.6h-153.6zM819.2 819.2a76.8 76.8 0 0 1-76.8 76.8h-460.8A76.8 76.8 0 0 1 204.8 819.2V409.6a25.6 25.6 0 0 0 9.728 0h204.8a25.6 25.6 0 0 0 25.6-25.6v-204.8h297.472A76.8 76.8 0 0 1 819.2 256z\" fill=\"#333333\" p-id=\"7692\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/分页.svg
// module id = 7ztl
// module chunks = 55